//
//
//
//
//
//
//
//
//
//
//
//
//

import { openWordStudy } from '@/utils/openWordStudy'

export default {
  name: 'WordStudyChip',
  props: {
    word: { type: String, default: '' },
    meaning: { type: String, default: '' },
    block: { type: Boolean, default: false }
  },
  computed: {
    displayWord () {
      return (this.word || '').trim() || '单词'
    }
  },
  methods: {
    go () {
      if (!this.word) return
      openWordStudy(this.$router, this.word)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/innovation/WordStudyChip.vue